import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CdkMenuModule } from '@angular/cdk/menu';
import { FormsModule } from '@angular/forms';

/**
 * Farbauswahl: ein Knopf zeigt die aktuelle Farbe, die Auswahl erscheint erst
 * im Popup. Dort stehen die Palettenfarben als Schnellauswahl, darunter ein
 * freies Farbfeld für alles andere.
 *
 * Die Palette bekommt der Aufrufer herein — für Tourfarben ist das dieselbe,
 * aus der sonst die Index-Farben stammen, damit eine fest vergebene Farbe
 * optisch zu den automatisch vergebenen passt. Ein leerer Wert bedeutet
 * "keine feste Farbe".
 */
@Component({
  selector: 'app-color-picker',
  standalone: true,
  imports: [CdkMenuModule, FormsModule],
  templateUrl: './color-picker.component.html',
})
export class ColorPickerComponent {
  /** Aktuell gesetzte Farbe als Hex (#rrggbb) oder null für "keine feste Farbe" */
  @Input() value: string | null = null;

  /** Farben der Schnellauswahl */
  @Input() palette: string[] = [];

  /** Farbe des freien Farbfelds, solange nichts gesetzt ist */
  @Input() placeholderColor = '#53aae8';

  /** Text auf dem Knopf, solange keine Farbe gesetzt ist */
  @Input() emptyHint = 'Keine feste Farbe';

  @Output() valueChange = new EventEmitter<string | null>();

  protected select(color: string): void {
    this.value = color;
    this.valueChange.emit(color);
  }

  protected clear(): void {
    this.value = null;
    this.valueChange.emit(null);
  }

  /** Vergleich unabhängig von Groß-/Kleinschreibung, damit auch #53AAE8 als ausgewählt gilt. */
  protected isSelected(color: string): boolean {
    return !!this.value && this.value.toLowerCase() === color.toLowerCase();
  }
}
